import React, { useState, useEffect } from 'react';
import { FiUsers } from "react-icons/fi";
import { getCigsidaInternationalExperts } from '../api/cigsidaApi';
import '../styles/Experts.css';

const DEFAULT_EXPERTS = [

];

export default function Experts() {
  const [expertsList, setExpertsList] = useState(DEFAULT_EXPERTS);
  const [cigsidaExperts, setCigsidaExperts] = useState([]);
  const [cigsidaError, setCigsidaError] = useState('');

  useEffect(() => {
    try {
      const saved = localStorage.getItem('iamar_experts_data');
      if (saved) {
        setExpertsList(JSON.parse(saved));
      }
    } catch (e) {
      console.error(e);
    }

    let isCurrent = true;

    const loadCigsidaExperts = async () => {
      try {
        const members = await getCigsidaInternationalExperts();
        if (isCurrent) {
          setCigsidaExperts(members.map((member) => ({
            id: `cigsida-${member.id}`,
            name: member.name,
            title: member.title,
            company: member.organization,
            company_logo: member.company_logo_url,
            image: member.image_url,
            domain: 'Experts internationaux SSR',
            isCigsidaExpert: true,
          })));
        }
      } catch (error) {
        console.error('Unable to load CIGSIDA international SSR experts:', error);
        if (isCurrent) setCigsidaError('Les experts internationaux SSR ne sont pas disponibles pour le moment.');
      }
    };

    loadCigsidaExperts();
    return () => {
      isCurrent = false;
    };
  }, []);

  const cigsidaExpertNames = new Set(
    cigsidaExperts.map((expert) => expert.name.trim().toLowerCase())
  );
  const displayedExperts = [
    ...cigsidaExperts,
    ...expertsList.filter((expert) => !cigsidaExpertNames.has(expert.name.trim().toLowerCase())),
  ].filter((expert, index, experts) => (
    experts.findIndex((candidate) => candidate.name.trim().toLowerCase() === expert.name.trim().toLowerCase()) === index
  ));

  return (
    <div className="experts-page">
      <div className="expert-header-banner experts-banner">
         <div className="banner-overlay">
            <span className="banner-tag">PLATEFORME IAMAR</span>
            <h1>Nos Experts</h1>
            <p>Un réseau mondial de spécialistes de haut niveau au service de la gouvernance et de la sécurité</p>
         </div>
      </div>

      <div className="expert-content-container">
         <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3>Nos Experts</h3>
         </div>
         <p className="cigsida-experts-intro">
           Les experts internationaux SSR du comité CIGSIDA sont également présentés ici.
         </p>
         {cigsidaError && <p className="cigsida-experts-notice" role="status">{cigsidaError}</p>}
        
        <div className="experts-grid">
           {displayedExperts.map(e => (
             <div className="expert-card" key={e.id}>
                <div className="expert-media">
                   {e.image ? (
                     <img src={e.image} alt={e.name} />
                   ) : (
                     <div style={{ width: '100%', height: '100%', minHeight: 260, background: '#1e293b', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>
                       <FiUsers size={48} />
                     </div>
                   )}
                   {e.countryCode && (
                     <div className="expert-flag-box">
                        <img 
                          src={`https://flagcdn.com/72x54/${e.countryCode}.png`} 
                          alt={e.country} 
                          className="api-flag-v2"
                        />
                     </div>
                   )}
                </div>
                <div className="expert-info">
                   <h4>{e.name}</h4>
                   <p className="expert-title-v2">{e.title}</p>
                   {e.isCigsidaExpert && <span className="cigsida-expert-tag">Expert international SSR</span>}
                   
                   <div className="expert-meta-blueprint">
                      <div className="meta-left">
                         {e.company_logo && <img src={e.company_logo} alt={e.company} className="company-logo-img" />}
                         <span className="company-text">{e.company || e.country || e.domain}</span>
                      </div>                  
                   </div>
                </div>
             </div>
           ))}
        </div>
      </div>
    </div>
  );
}
